"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NhsButton = exports.ButtonLink = exports.Button = void 0;
const react_1 = __importDefault(require("react"));
const __1 = require("../..");
const NhsLogoOnWhite_1 = require("../../shared/assets/NhsLogoOnWhite");
const tokens_1 = require("../../styles/tokens");
const Button_styles_1 = require("./Button.styles");
const setIconDimension = (dimension, withText) => {
    switch (dimension) {
        case "large":
            return withText
                ? tokens_1.buttonInputFieldIconSizes["large"].withText
                : tokens_1.buttonInputFieldIconSizes["large"].default;
        case "medium":
            return withText
                ? tokens_1.buttonInputFieldIconSizes["medium"].withText
                : tokens_1.buttonInputFieldIconSizes["medium"].default;
        case "small":
            return withText
                ? tokens_1.buttonInputFieldIconSizes["small"].withText
                : tokens_1.buttonInputFieldIconSizes["small"].default;
        default:
            return 2;
    }
};
const setTextSize = (dimension) => {
    switch (dimension) {
        case "small":
            return "note";
        case "large":
        case "medium":
        default:
            return "label";
    }
};
const setInnerStyle = (text, icon) => {
    if (text) {
        return icon ? "textWithIcon" : "text";
    }
    return "icon";
};
const setIconColour = (theme, iconColour, isButtonDisabled) => {
    if (isButtonDisabled)
        return theme === "transparent" ? "stone" : "zinc";
    const shouldIconBeWhite = !!["primary", "danger", "success"].includes(theme);
    return shouldIconBeWhite ? "white" : iconColour;
};
const renderButtonIcon = (icon, dimension, theme, hasText, disabled) => {
    return (react_1.default.createElement(__1.Icon, Object.assign({ name: icon.name, size: setIconDimension(dimension, hasText), style: icon.style, colour: setIconColour(theme, icon.colour, disabled), rotation: icon.rotation, title: icon.title }, icon.props)));
};
/**
 * Used to ensure that when styling a link as a button by wrapping a button with an anchor,
 * focus states for links occupy the exact size of the button

 **/
const ButtonLinkAnchor = react_1.default.forwardRef((_a, forwardedRef) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (react_1.default.createElement(Button_styles_1.StyledButtonLinkFlex, null,
        react_1.default.createElement(Button_styles_1.StyledButtonLink, Object.assign({ ref: forwardedRef }, props), children)));
});
/**
 * @deprecated please use <Ds.Badge>New</Ds.Badge> instead
 */
exports.Button = react_1.default.forwardRef((_a, forwardedRef) => {
    var { theme = "primary", disabled = false, dimension = "medium", text = "", icon, as = "button" } = _a, props = __rest(_a, ["theme", "disabled", "dimension", "text", "icon", "as"]);
    if (props.title) {
        console.warn("Do not use title attribute on Button. Use aria-label for an accessible label that is not visible.");
    }
    return (react_1.default.createElement(Button_styles_1.StyledButton, Object.assign({ as: as, theme: theme, dimension: dimension, disabled: disabled, innerStyle: setInnerStyle(!!text, !!icon) }, props, { ref: forwardedRef }),
        icon &&
            icon.placement !== "end" &&
            renderButtonIcon(icon, dimension, theme, !!text, disabled),
        text && (react_1.default.createElement(__1.Text, { variant: setTextSize(dimension), as: "span", skinny: true, props: { style: { color: "currentColor" } } }, text)),
        icon &&
            icon.placement === "end" &&
            renderButtonIcon(icon, dimension, theme, !!text, disabled)));
});
exports.Button.displayName = "Button";
/**
 * Styled as {@link Button} component, but has all the HTML attributes of an anchor tag
 * */
exports.ButtonLink = react_1.default.forwardRef((_a, forwardedRef) => {
    var { theme = "primary", dimension = "medium", text = "", icon } = _a, props = __rest(_a, ["theme", "dimension", "text", "icon"]);
    return (react_1.default.createElement(ButtonLinkAnchor, Object.assign({ ref: forwardedRef }, props),
        react_1.default.createElement(exports.Button, { as: "span", theme: theme, dimension: dimension, text: text, icon: icon })));
});
const NHS_BUTTON_SIZE = "large";
/**
 * A link to be used for NHSmail and NHS (patient) SSO, displaying the NHS logo
 * Styled as {@link Button} component, but has all the HTML attributes of an anchor tag
 * */
const NhsButton = ({ children, disabled = false, href, onClick, }) => (react_1.default.createElement(ButtonLinkAnchor, { href: href, onClick: onClick },
    react_1.default.createElement(Button_styles_1.StyledButton, { as: "span", theme: "primary", disabled: disabled, dimension: NHS_BUTTON_SIZE, innerStyle: setInnerStyle(true, true) },
        react_1.default.createElement(__1.StackPanel, { gutter: 1, orientation: "horizontal" },
            react_1.default.createElement(Button_styles_1.StyledLogo, null,
                react_1.default.createElement(NhsLogoOnWhite_1.NhsLogoOnWhite, { isDecorative: true })),
            react_1.default.createElement(__1.Text, { variant: setTextSize(NHS_BUTTON_SIZE), as: "span", skinny: true, props: { style: { color: "currentColor" } } }, children)))));
exports.NhsButton = NhsButton;
//# sourceMappingURL=Button.js.map